<template>
  <RouterView />
</template>

<script setup>
  defineOptions({ name: "App" });
</script>
